import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Compteur de messages non lus par dossier (rafraîchi toutes les 20s)
export const useUnreadMessages = (projects, token) => {
  const [unread, setUnread] = useState({});
  const ids = (projects || []).map((p) => p.id).join(',');

  const refresh = useCallback(async () => {
    if (!ids || !token) { setUnread({}); return; }
    try {
      const res = await axios.get(`${API}/project-messages/unread-summary`, {
        params: { ids },
        headers: { Authorization: `Bearer ${token}` },
      });
      setUnread(res.data?.unread || {});
    } catch {}
  }, [ids, token]);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 20000);
    return () => clearInterval(t);
  }, [refresh]);

  return { unread, refresh, total: Object.values(unread).reduce((a, b) => a + b, 0) };
};

export const UnreadDot = ({ count, className = '' }) => {
  if (!count) return null;
  return (
    <span
      data-testid="unread-badge"
      title={`${count} nouveau${count > 1 ? 'x' : ''} message${count > 1 ? 's' : ''}`}
      className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold leading-none shadow-md animate-pulse ${className}`}
    >
      {count > 9 ? '9+' : count}
    </span>
  );
};
